export default __webpack_public_path__ + "static/alfred_add_custom_coupang-7ca9c1dc11946d1946971f8f4ac36fd3.png";